import styled from 'styled-components'

export const TermsContainer = styled.div`
  max-width: 850px;
  margin: 40px auto;
  font-family: 'Montserrat', sans-serif;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .hero-section {
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    padding: 56px 32px;
    text-align: center;
    color: #f8fafc;

    .back-button {
      position: absolute;
      top: 24px;
      left: 24px;
      display: flex;
      align-items: center;
      gap: 8px;
      background: transparent;
      color: #94a3b8;
      border: none;
      font-family: inherit;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover {
        color: #ffffff;
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    .hero-icon-wrapper {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      margin-bottom: 24px;
      backdrop-filter: blur(4px);
    }

    .hero-icon {
      font-size: 2.5rem;
      color: #38bdf8;
    }

    h1 {
      font-size: 2.2rem;
      margin-bottom: 16px;
      font-weight: 800;
      letter-spacing: -0.5px;
    }

    .hero-description {
      font-size: 1.1rem;
      color: #cbd5e1;
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.6;

      strong {
        color: #ffffff;
      }
    }
  }

  .document-body {
    padding: 48px;
  }

  .section-block {
    margin-bottom: 36px;

    &:last-child {
      margin-bottom: 0;
    }

    h2 {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 1.3rem;
      color: #0f172a;
      margin-bottom: 16px;
      border-bottom: 1px solid #f1f5f9;
      padding-bottom: 8px;

      .section-icon {
        color: #64748b;
        font-size: 1.2rem;
      }
    }

    p {
      font-size: 1rem;
      color: #475569;
      line-height: 1.7;
      text-align: justify;
    }

    code {
      font-family: 'Courier New', monospace;
      background-color: #f1f5f9;
      color: #e11d48;
      padding: 2px 6px;
      border-radius: 4px;
      font-weight: 600;
      font-size: 0.9em;
    }

    ul {
      margin-top: 12px;
      padding-left: 24px;
    }

    li {
      font-size: 1rem;
      color: #475569;
      line-height: 1.6;
      margin-bottom: 12px;

      strong {
        color: #1e293b;
      }
    }
  }

  .lgpd-highlight {
    background-color: #f0fdf4;
    border: 1px solid #bbf7d0;
    padding: 24px;
    border-radius: 12px;

    h2 {
      border-bottom-color: #dcfce7;
      color: #166534;

      .lgpd-icon {
        color: #22c55e;
      }
    }

    p,
    li {
      color: #166534;
    }
  }

  footer {
    background-color: #f8fafc;
    border-top: 1px solid #e2e8f0;
    padding: 32px 48px;

    .footer-content {
      text-align: center;

      p {
        color: #64748b;
        font-size: 0.95rem;
        margin-bottom: 8px;

        strong {
          color: #334155;
        }

        a {
          color: #3b82f6;
          text-decoration: none;
          font-weight: 500;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .copyright {
        margin-top: 16px;
        font-size: 0.85rem;
        color: #94a3b8;
      }
    }
  }

  @media (max-width: 768px) {
    margin: 20px;

    .hero-section {
      padding: 40px 20px;

      h1 {
        font-size: 1.8rem;
      }
    }

    .document-body,
    footer {
      padding: 32px 24px;
    }

    .section-block p,
    .section-block li {
      text-align: left;
    }
  }
`
